import state from '../state';

const t = state.t.prefix('compact_date_suffix');

export default function secondsToHr (seconds) {
  let minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  let hours = Math.floor(minutes / 60);
  minutes -= hours * 60;

  let days = Math.floor(hours / 24);
  hours -= days * 24;

  let weeks = Math.floor(days / 7);
  days -= weeks * 7;

  // const months = Math.floor(weeks / 4);
  // weeks -= months * 4;

  let result = [];

  if (weeks > 0) {
    result.push(weeks + t('weeks'));
  }
  if (days > 0) {
    result.push(days + t('days'));
  }
  if (hours > 0 && weeks === 0) {
    result.push(hours + t('hours'));
  }
  if (minutes > 0 && days === 0 && weeks === 0) {
    result.push(minutes + t('minutes'));
  }
  if (seconds > 0 && hours === 0 && days === 0 && weeks === 0) {
    result.push(seconds + t('seconds'));
  }

  return result.join(' ');
}
